// // client/src/pages/play/Welcome.tsx
import React from 'react';
import { Box, Button, Heading, Text, VStack, Flex, useBreakpointValue } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

const MotionDiv = motion.div;

export default function Welcome() {
  const navigate = useNavigate();
  
  // Responsive values
  const headingSize = useBreakpointValue({ base: '2xl', sm: '3xl', md: '4xl', lg: '5xl' });
  const textSize = useBreakpointValue({ base: 'lg', sm: 'xl', md: '2xl' });
  const buttonSize = useBreakpointValue({ base: 'md', md: 'lg' });
  const spacing = useBreakpointValue({ base: 6, md: 8, lg: 10 });

  return (
    <Flex 
      minH="100vh" 
      w="100vw" 
      align="center" 
      justify="center" 
      position="relative"
      overflowX="hidden"
      px={4}
    >
      <VStack
        spacing={spacing}
        w="full"
        maxW={{ base: "85%", sm: "80%", md: "75%", lg: "70%", xl: "800px" }}
        mx="auto"
        textAlign="center"
        py={{ base: 22, md: 26, lg: 10 }}
        px={{ base: 2, md: 4 }}
        bg="rgba(0, 0, 0, 0)" // Semi-transparent dark overlay
        backdropFilter="blur(8px)"
        borderRadius="xl"
        border="1px solid"
        borderColor="rgba(255,255,255,0.1)"
        zIndex={1}
      >
        <MotionDiv
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <Heading
            as="h1"
            size={headingSize}
            // bgGradient="linear(to-r, purple.300, pink.300)"
        bgGradient="linear(to-r, purple.300, pink.300)"
            bgClip="text"
            // mb={{ base: 4, md: 6 }}
        mb={2} // Reduced margin
            lineHeight="1.2"
            // textShadow="0 2px 4px rgba(0,0,0,0.5)"
          >
            Welcome to Soul Mirror
          </Heading>
          <Text 
            fontSize={textSize} 
            color="whiteAlpha.900"
            fontWeight="medium"
            textShadow="0 2px 4px rgba(0,0,0,0.5)"
            maxW={{ base: '100%', md: '2xl' }} 
            mx="auto"
          >
            Discover your inner archetype through an interactive journey
          </Text>
        </MotionDiv>

        <MotionDiv
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.8 }}
        >
          <Button
            size={buttonSize}
            colorScheme="purple"
            onClick={() => navigate('/play/capture')}
            px={{ base: 8, md: 10 }}
            py={{ base: 6, md: 7 }}
            fontSize={{ base: 'lg', md: 'xl' }}
            w={{ base: 'full', sm: 'auto' }}
            minW="200px"
            h="auto"
            _hover={{
              transform: 'translateY(-2px)',
              boxShadow: 'xl',
            }}
            transition="all 0.2s"
          >
            Begin Journey
          </Button>
        </MotionDiv>
      </VStack>
    </Flex>
  );
}